import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAspectRatios, LazyCbChange, LazyCbModule, LazyPgrStart, LazySepacSectionTrust, LazySepacSectionTrustItem, LazyAlertbox, LazyCard, LazyCardSection, LazyCarouselSection, LazyCollapseSection, LazyDownloadSection, LazyExpansionPanelSection, LazyFooterDefault, LazyHeaderDefault, LazyImageTextSection, LazyStepSection, LazyTrustpilotWidget, LazyTuevWidget, LazyTracking, LazyWPBlockArrow, LazyWPBlockFAQ, LazyWPBlockGrid, LazyWPBlockHowto, LazyWPBlockPartner, LazyWPBlockPartnernetwork, LazyWPBlockPerks, LazyWPBlockReviews, LazyWPBlockSectionCard, LazyWPBlockSectionExpansionpanel, LazyWPBlockSectionHeroItem, LazyWPBlockSectionText, LazyWPBlockStickyHeader, LazyWPBlockThisispflegede, LazyWPBlockTuev, LazyWPBlockWizco, LazyWPElementHeading, LazyWPElementImage, LazyWPElementParagraph, LazyWPElementRichtext, LazyWPIntro, LazyWizPage } from '#components'
const lazyGlobalComponents = [
  ["AspectRatios", LazyAspectRatios],
["CbChange", LazyCbChange],
["CbModule", LazyCbModule],
["PgrStart", LazyPgrStart],
["SepacSectionTrust", LazySepacSectionTrust],
["SepacSectionTrustItem", LazySepacSectionTrustItem],
["Alertbox", LazyAlertbox],
["Card", LazyCard],
["CardSection", LazyCardSection],
["CarouselSection", LazyCarouselSection],
["CollapseSection", LazyCollapseSection],
["DownloadSection", LazyDownloadSection],
["ExpansionPanelSection", LazyExpansionPanelSection],
["FooterDefault", LazyFooterDefault],
["HeaderDefault", LazyHeaderDefault],
["ImageTextSection", LazyImageTextSection],
["StepSection", LazyStepSection],
["TrustpilotWidget", LazyTrustpilotWidget],
["TuevWidget", LazyTuevWidget],
["Tracking", LazyTracking],
["WPBlockArrow", LazyWPBlockArrow],
["WPBlockFAQ", LazyWPBlockFAQ],
["WPBlockGrid", LazyWPBlockGrid],
["WPBlockHowto", LazyWPBlockHowto],
["WPBlockPartner", LazyWPBlockPartner],
["WPBlockPartnernetwork", LazyWPBlockPartnernetwork],
["WPBlockPerks", LazyWPBlockPerks],
["WPBlockReviews", LazyWPBlockReviews],
["WPBlockSectionCard", LazyWPBlockSectionCard],
["WPBlockSectionExpansionpanel", LazyWPBlockSectionExpansionpanel],
["WPBlockSectionHeroItem", LazyWPBlockSectionHeroItem],
["WPBlockSectionText", LazyWPBlockSectionText],
["WPBlockStickyHeader", LazyWPBlockStickyHeader],
["WPBlockThisispflegede", LazyWPBlockThisispflegede],
["WPBlockTuev", LazyWPBlockTuev],
["WPBlockWizco", LazyWPBlockWizco],
["WPElementHeading", LazyWPElementHeading],
["WPElementImage", LazyWPElementImage],
["WPElementParagraph", LazyWPElementParagraph],
["WPElementRichtext", LazyWPElementRichtext],
["WPIntro", LazyWPIntro],
["WizPage", LazyWizPage],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
